import { useEffect, useState } from "react";
import api from "../api";

export default function AdminRoles() {
  const [roles, setRoles] = useState([]);
  const [showUsersForRole, setShowUsersForRole] = useState(null); // Rolle, für die User angezeigt werden
  const [usersForRole, setUsersForRole] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", label: "", icon: "", order: 0 });
  const [loading, setLoading] = useState(false);
  const [showNewForm, setShowNewForm] = useState(false);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    const res = await api.get("/roles");
    setRoles(res.data);
  };

  const startEdit = (role) => {
    setEditing(role.id);
    setForm({ name: role.name, label: role.label, icon: role.icon || "", order: role.order });
    setShowNewForm(false);
  };

  const cancelEdit = () => {
    setEditing(null);
    setForm({ name: "", label: "", icon: "", order: 0 });
    setShowNewForm(false);
  };

  const saveRole = async () => {
    setLoading(true);
    if (editing) {
      await api.put(`/roles/${editing}`, form);
    } else {
      await api.post("/roles", form);
    }
    setLoading(false);
    cancelEdit();
    fetchRoles();
  };

  const deleteRole = async (id) => {
    if (!window.confirm("Rolle wirklich löschen?")) return;
    setLoading(true);
    await api.delete(`/roles/${id}`);
    setLoading(false);
    fetchRoles();
  };

  // Benutzer für Rolle laden
  const fetchUsersForRole = async (roleName) => {
    setLoadingUsers(true);
    try {
      const res = await api.get(`/admin/users?role=${encodeURIComponent(roleName)}`);
      setUsersForRole(res.data.items);
    } catch (e) {
      setUsersForRole([]);
    }
    setLoadingUsers(false);
  };

  return (
    <div className="home-page">
  <section style={{width:'100vw', margin:0, padding:0, position:'relative', left:'-120px'}}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Rollenverwaltung</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Verwalte alle Rollen, ihre Namen, Symbole und Reihenfolge.</p>
      </section>
  <section style={{width:'100vw',margin:0,padding:0, position:'relative', left:'120px'}}>
        <table style={{width:'100%', borderCollapse:'collapse'}}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Label</th>
              <th>Symbol</th>
              <th>Reihenfolge</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {roles.map(role => (
              <tr key={role.id}>
                <td>{role.name}</td>
                <td>{role.label}</td>
                <td>{role.icon}</td>
                <td>{role.order}</td>
                <td>
                  <button className="hero-btn-primary" style={{marginRight:8}} onClick={() => startEdit(role)} disabled={loading}>Bearbeiten</button>
                  <button className="hero-btn-danger" style={{marginRight:8}} onClick={() => deleteRole(role.id)} disabled={loading}>Löschen</button>
                  <button className="hero-btn-secondary" onClick={() => { setShowUsersForRole(role.name); fetchUsersForRole(role.name); }} disabled={loading}>Benutzer anzeigen</button>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan={5} style={{textAlign:'center', padding:'16px 0'}}>
                <button className="hero-btn-primary" onClick={() => { setEditing(null); setForm({ name: "", label: "", icon: "", order: 0 }); setShowNewForm(true); }}>Neue Rolle anlegen</button>
              </td>
            </tr>
          </tbody>
        </table>
  {(editing !== null || showNewForm) && (
          <div style={{marginTop:32, textAlign:'center'}}>
            <h2>{editing ? "Rolle bearbeiten" : "Neue Rolle anlegen"}</h2>
            <form onSubmit={e => {e.preventDefault(); saveRole();}} style={{display:'inline-block', textAlign:'left', maxWidth:400}}>
              <label>Name:<br/>
                <input type="text" value={form.name} onChange={e => setForm(f => ({...f, name: e.target.value}))} required disabled={loading}/>
              </label><br/><br/>
              <label>Label:<br/>
                <input type="text" value={form.label} onChange={e => setForm(f => ({...f, label: e.target.value}))} required disabled={loading}/>
              </label><br/><br/>
              <label>Symbol (Emoji):<br/>
                <input type="text" value={form.icon} onChange={e => setForm(f => ({...f, icon: e.target.value}))} disabled={loading}/>
              </label><br/><br/>
              <label>Reihenfolge:<br/>
                <input type="number" value={form.order} onChange={e => setForm(f => ({...f, order: Number(e.target.value)}))} required disabled={loading}/>
              </label><br/><br/>
              <button className="hero-btn-primary" type="submit" disabled={loading}>Speichern</button>
              <button className="hero-btn-secondary" type="button" onClick={cancelEdit} style={{marginLeft:8}} disabled={loading}>Abbrechen</button>
            </form>
          </div>
        )}
      {/* Modal für Benutzer mit Rolle */}
      {showUsersForRole && (
        <div style={{position:'fixed', top:0, left:0, width:'100vw', height:'100vh', background:'rgba(0,0,0,0.35)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center'}}>
          <div style={{background:'#fff', padding:'32px 40px 24px 40px', borderRadius:14, minWidth:380, maxWidth:520, maxHeight:'80vh', overflowY:'auto', boxShadow:'0 4px 32px rgba(0,0,0,0.18)', position:'relative'}}>
            <button className="hero-btn-secondary" style={{position:'absolute', top:18, right:18, fontSize:18, padding:'4px 12px', borderRadius:6, background:'#f5f5f5', color:'#333', border:'1px solid #ddd', cursor:'pointer'}} onClick={()=>setShowUsersForRole(null)} aria-label="Schließen">×</button>
            <h2 style={{textAlign:'center', margin:'0 0 18px 0', fontSize:'1.35em', fontWeight:600, letterSpacing:0.5, color:'#222'}}>Benutzer mit Rolle: <span style={{color:'#32CD89'}}>{showUsersForRole}</span></h2>
            {loadingUsers ? <div style={{textAlign:'center', margin:'32px 0'}}>Lade Benutzer ...</div> : (
              usersForRole.length === 0 ? <div style={{textAlign:'center', color:'#888', margin:'32px 0'}}>Keine Benutzer mit dieser Rolle gefunden.</div> : (
                <div style={{overflowX:'auto'}}>
                  <table style={{width:'100%', borderCollapse:'collapse', marginTop:8, fontSize:'1em', background:'#fff', borderRadius:8, boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
                    <thead>
                      <tr style={{background:'#32CD89'}}>
                        <th style={{padding:'10px 8px', borderBottom:'1px solid #e0e0e0', textAlign:'left', fontWeight:500, color:'#fff'}}>Benutzername</th>
                        <th style={{padding:'10px 8px', borderBottom:'1px solid #e0e0e0', textAlign:'left', fontWeight:500, color:'#fff'}}>E-Mail</th>
                        <th style={{padding:'10px 8px', borderBottom:'1px solid #e0e0e0', textAlign:'left', fontWeight:500, color:'#fff'}}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersForRole.map(u => (
                        <tr key={u.id} style={{background:u.status==='active'?'#eafbe7':'#fff'}}>
                          <td style={{padding:'8px 8px', borderBottom:'1px solid #f0f0f0', color:'#222'}}>{u.username}</td>
                          <td style={{padding:'8px 8px', borderBottom:'1px solid #f0f0f0', color:'#222'}}>{u.email}</td>
                          <td style={{padding:'8px 8px', borderBottom:'1px solid #f0f0f0', color:u.status==='active'?'#32CD89':'#888'}}>{u.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}
          </div>
        </div>
      )}
      </section>
    </div>
  );
}
